import React, { useState } from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Useletter from '../Useletter';
import Foter from '../Foter';
function Contact() {
    const[name, setName]=useState("")
    const[email, setEmail]=useState("")
    const[number, setNumber]=useState("")


  return (
    <div>
        
<br />
<Container>
    <Row>
       
        
      <div className="contact" style={{textAlign:"left",fontSize:"20px", fontFamily:"Alata,sans serif",color:"#303030"}}><label htmlFor=""><span>CONTACT US</span></label>
      </div> 
      <Col> 
<br />   
<div className="contact-container1" style={{backgroundColor:"#F3F3F3",fontFamily:"Alata,sans serif",textAlign:"left",height:"780px",width:""}}>  
      <div class="">
        <p><strong>Let us know what you think.</strong></p>
<p><span style={{fontSize:"small"}}>Should you have any questions, comments, or inquiries please reach out to us.</span></p>
<h4>FOR ONLINE STORE</h4>
<p><strong>BY EMAIL</strong><br/><a href="mailto:eshop@junaidjamshed.com"><span style={{fontSize:"small"}}>eshop@junaidjamshed.com</span></a></p>
<p><strong>BY TELEPHONE</strong><br/><span style={{fontSize:"small"}}><spa style={{color: "#0000ff"}}><a href="tel:021111112111"><span style={{color: "#0000ff"}}>021 111 112 111</span></a></spa> (9am - 10pm , Monday - Saturday, Sunday 11am - 08pm )</span></p>
<p><strong>BY MAIL</strong><br/><span style={{fontSize:"small"}}>J. Junaid Jamshed Pvt Ltd</span><br/><span style={{fontSize:"small"}}>Head office, 40 Sector 19, Korangi Industrial Area</span></p>
<h4>FOR OUTLETS INQUIRIES</h4>
<p><strong>BY EMAIL</strong><br/><span style={{fontSize:"small"}}>feedback@junaidjamshed.com</span></p>
<p><strong>BY TELEPHONE</strong><br/><span style={{fontSize:"small"}}><span style={{color: "#0000ff"}}><a href="tel:021 111 112 111"><span style={{color: "#0000ff"}}>021 111 112 111</span></a></span> (9am - 6pm , Monday - Saturday )</span></p>
<p><strong>IN-STORE LOCATIONS &amp; PHONE NUMBERS</strong><br/><span style={{fontSize:"small"}}>For complete store details, <a href="https://www.junaidjamshed.com/store-locations">click here</a></span></p>
<h4>FOR CORPORATE ORDERS AND INQUIRIES</h4>
<p><strong>BY EMAIL</strong><br/><span style={{fontSize:"small"}}>corporate@junaidjamshed.com</span></p><style></style>    </div>
</div> </Col>

      
      
      
      <Col>
      <br />
<div className="contact-container2" style={{fontFamily:"Alata,sans serif"}}>  
      <h1 style={{fontSize:"25px",textAlign:"left"}}>CONTACT US</h1>
      <br /><br />

      <label class="" for=""><strong style={{textAlign:"left",marginRight:"500px"}}>Name</strong></label> <br /><br />
      <input style={{border:"none",borderBottom:"1px solid black",outline:"none",width:"100%"}} name="name" id="name" title="" value={name}  type="text" onChange={(e) => setName(e.target.value)} ></input>
<br /> <br />
      <div className="req"> <span style={{fontSize:"12px",fontFamily:"Alata,sans serif",color:"red",marginRight:"430px"}}>This is Required Field</span></div>
      
<br />
      <label class="" for=""><strong style={{textAlign:"left",marginRight:"500px"}}>Email</strong></label> <br /><br />
      <input style={{border:"none",borderBottom:"1px solid black",outline:"none",width:"100%"}} name="email" id="email" title="" value={email}  type="email" onChange={(e) => setEmail(e.target.value)} ></input>

      <br /> <br />
      <div className="req"> <span style={{fontSize:"12px",fontFamily:"Alata,sans serif",color:"red",marginRight:"430px"}}>This is Required Field</span></div>
      
<br />
      <label class="" for=""><strong style={{textAlign:"left",marginRight:"430px"}}>Phone Number</strong></label> <br /><br />
      <input style={{border:"none",outline:"none",width:"100%",borderBottom:"1px solid black"}} name="number" id="number" title="number" value={number}  type="text" onChange={(e) => setNumber(e.target.value)} ></input>

      <div class="control">
        <br /><br />
      <label class="" for=""><strong style={{textAlign:"left",marginRight:"390px"}}>What's on your mind</strong></label> <br /><br />

    <textarea style={{width:"100%",border:"none",borderBottom:"1px solid black",outline:"none"}} name="comment" id="comment" title="What’s on your mind?" class="input-text mage-error" cols="5" rows="3" data-validate="{required:true}" aria-required="true" aria-describedby="comment-error" aria-invalid="true" data-gtm-form-interact-field-id="0"></textarea>
    <div className="req"> <span style={{fontSize:"12px",fontFamily:"Alata,sans serif",color:"red",marginRight:"430px"}}>This is Required Field</span></div>
    </div>
    <input style={{border:"none",borderBottom:"1px solid black",outline:"none",width:"100%"}} name="name" id="name" title=""  type="text" ></input>
    {/* <input name="name" id="name" title="Name" value="" class="input-text mage-error" type="text" data-validate="{required:true}" aria-required="true" aria-describedby="name-error" aria-invalid="true" data-gtm-form-interact-field-id="1"/> */}

    <button  className="bt" type='button' style={{fontFamily:"Alata,sans serif",marginTop:"50px",textAlign:"left",marginRight:"500px"}}>SUBMIT</button>




</div> </Col>
</Row>
</Container>
<Useletter/>
<Foter/>
      </div>

  )
}

export default Contact
